/* eslint-disable @typescript-eslint/no-explicit-any */
import { ENV } from '@/constants/env'
import * as Sentry from '@sentry/react'

export class SentryErrorAlert {
  private initialized = false
  init = () => {
    if (ENV.sentryDsn) {
      Sentry.init({
        dsn: ENV.sentryDsn,
        sendDefaultPii: true,
        ignoreErrors: [
          "This browser doesn't support the APIs required to use the Firebase SDK",
          /browser doesn't support the api/i,
          /push service error/i,
          /Unable to preload CSS/i,
          /text\/html' is not a valid JavaScript MIME type/i,
        ],
        beforeSend(event, hint) {
          const exception = hint?.originalException as any
          const errorMessage = exception.message
          if (
            exception?.isAxiosError &&
            exception?.response?.status >= 400 &&
            exception?.response?.status < 500
          ) {
            return null
          }
          if (
            /text\/html' is not a valid JavaScript MIME type/i.test(
              errorMessage,
            )
          ) {
            return null
          }
          if (/Unable to preload CSS/i.test(errorMessage)) return null
          if (/Registration failed - push service error/i.test(errorMessage)) {
            return null
          }
          // ignore push notification error
          if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
            if (
              errorMessage.includes('Firebase SDK') ||
              errorMessage.includes("browser doesn't support")
            ) {
              return null
            }
          }
          return event
        },
      })
      this.initialized = true
    }
  }
  errorAlert = (error: Error, context?: unknown, cetegory?: string) => {
    if (!this.initialized) return

    Sentry.withScope((scope) => {
      if (cetegory) {
        scope.setTag('category', cetegory)
      }
      if (context) {
        scope.setContext('job', context as Record<string, any>)
      }
      Sentry.captureException(error)
    })
  }
}

export const sentryErrorAlert = new SentryErrorAlert()
